import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AgentSummary } from "@/model";
import deploymentRepository from "@/repository/deploymentRepository";
import { deploymentQueryKeys } from "./keys";


export const useApplyService = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<AgentSummary, AxiosError>({
        mutationKey: ["agent-deploy", agentId],
        mutationFn: async () => {
            try {
                const { data } = await deploymentRepository.applyService(agentId);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: deploymentQueryKeys.agentSummary(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: deploymentQueryKeys.deploymentHistoryPageAll(agentId)
            });
        }
    });
};
